import type { IAnalytics } from './models/analytics';

export const analyticsX5Form: Partial<IAnalytics> = {
    // Электронная почта
    email: {
        focus: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            // eslint-disable-next-line sonarjs/no-duplicate-string
            block: 'Электронная почта',
            // eslint-disable-next-line sonarjs/no-duplicate-string
            label_detail: 'Ввод данных',
        },
        correct: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Электронная почта',
            // eslint-disable-next-line sonarjs/no-duplicate-string
            label_detail: 'Успешный ввод',
        },
        incorrect: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Электронная почта',
            // eslint-disable-next-line sonarjs/no-duplicate-string
            label_detail: 'Ошибка ввода',
        },
    },
    // Промокод
    promocode: {
        focus: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Промокод',
            label_detail: 'Ввод данных',
        },
        correct: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Промокод',
            label_detail: 'Успешный ввод',
        },
        incorrect: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Промокод',
            label_detail: 'Ошибка ввода',
        },
    },
    // Телефон
    phone: {
        focus: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Телефон',
            label_detail: 'Ввод данных',
        },
        correct: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Телефон',
            label_detail: 'Успешный ввод',
        },
        incorrect: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Телефон',
            label_detail: 'Ошибка ввода',
        },
    },
    // ФИО
    fullName: {
        focus: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'ФИО',
            label_detail: 'Ввод данных',
        },
        correct: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'ФИО',
            label_detail: 'Успешный ввод',
        },
        incorrect: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'ФИО',
            label_detail: 'Ошибка ввода',
        },
    },
    lastName: {
        focus: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Фамилия',
            label_detail: 'Ввод данных',
        },
        correct: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Фамилия',
            label_detail: 'Успешный ввод',
        },
        incorrect: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Фамилия',
            label_detail: 'Ошибка ввода',
        },
    },
    firstName: {
        focus: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Имя',
            label_detail: 'Ввод данных',
        },
        correct: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Имя',
            label_detail: 'Успешный ввод',
        },
        incorrect: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Имя',
            label_detail: 'Ошибка ввода',
        },
    },
    middleName: {
        focus: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Отчество',
            label_detail: 'Ввод данных',
        },
        correct: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Отчество',
            label_detail: 'Успешный ввод',
        },
        incorrect: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Отчество',
            label_detail: 'Ошибка ввода',
        },
    },
    // При доскроле до кнопки продолжить
    scrollToButton: {
        event: 'gtm_non_interaction_event',
        action: 'View',
        block: 'Анкета',
        label_detail: 'Просмотр',
    },
    // выбор гражданства
    resident: {
        // Клик по "Нет" если активировано "Да"
        buttonResidentClickNo: {
            event: 'gtm_interaction_event',
            action: 'Click',
            // eslint-disable-next-line sonarjs/no-duplicate-string
            block: 'У вас гражданство РФ',
            label_detail: 'Нет',
        },
        // Клик "На главную" в сценарии "У вас гражданство РФ-Нет "
        buttonResidentClickToMain: {
            event: 'gtm_interaction_event',
            action: 'Click',
            block: 'У вас гражданство РФ',
            label_detail: 'На главную',
        },
        // Клик по "Да" если активировано "Нет"
        buttonResidentClickYes: {
            event: 'gtm_interaction_event',
            action: 'Click',
            block: 'У вас гражданство РФ',
            label_detail: 'Да',
        },
    },
    // выбор даты рождения
    passportBirthDate: {
        focus: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            // eslint-disable-next-line sonarjs/no-duplicate-string
            block: 'Дата рождения',
            label_detail: 'Ввод данных',
        },
        correct: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Дата рождения',
            label_detail: 'Успешный ввод',
        },
        incorrect: {
            event: 'gtm_interaction_event',
            action: 'Enter',
            block: 'Дата рождения',
            label_detail: 'Ошибка ввода',
        },
    },
    // Клик по выбору пола
    sexChoice: {
        event: 'gtm_interaction_event',
        action: 'Choice',
        block: 'Выбор пола',
    },
    // Клик по продолжить и успешный переход на следующий шаг формы
    submit: {
        success: {
            event: 'gtm_interaction_event',
            action: 'Send',
            block: 'Шаг 1',
            label_detail: 'Успешная отправка формы',
            ymEvent: {
                method: 'reachGoal',
                params: 'send_step1_card_5',
            },
        },
        fail: {
            event: 'gtm_interaction_event',
            action: 'Send',
            block: 'Шаг 1',
            label_detail: 'Ошибка отправки формы',
        },
    },
};
